// 获得系统版本（PC-0，iOS-1，Android-2）
export const getSystem = () => {
    let system = "Other";
    /*
    * ipad环境判断更新
    * iOS pre 13 以前以ua作判断，13后以platform及maxTouchPoints做判断
    */
    var isiPad = (navigator.userAgent.match(/(iPad)/) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1));
    if (/(iPhone|iPad|iPod|iOS)/i.test(window.navigator.userAgent) || isiPad) {
        system = "iOS";
    } else if (/(Android)/i.test(window.navigator.userAgent)) {
        system = "android";
    } else {
        system = "PC";
    }

    return system;
};

export const deviceType = () => {
    if (getSystem() == 'PC') {
        return 'pc'
    } else {
        return 'wap'
    }
}

// 浏览器语言 默认英语
export const lang = () => {
    const primaryLanguage = (navigator.language || navigator.browserLanguage || navigator.userLanguage).toLowerCase();
    if (primaryLanguage.startsWith('zh')) {
        return 'cn';
    } else if (primaryLanguage.startsWith('th')) {
        return 'th';
    } else {
        return 'en';
    }
}

// 手机格式校验
export const PhoneCheck = (phone, areacode) => {
    const validateFormat = (pattern) => {
        return phone.match(pattern);
    };

    switch (areacode) {
        case "886": // 臺灣 09 開頭 10位數字
            var patt1 = /^(\+886\s)?[0]{0,1}[9]{1}\d{8}$/;
            break;
        case "852": // 香港 5、6、9 開頭 8位數字
            var patt2 = /^(\+852\s)?[569]{1}\d{7}$/;
            break;
        case "853": // 澳門 6 開頭 8位數字
            var patt3 = /^(\+853\s)?[6]\d{7}$/;
            break;
        default:
            // 格式錯誤
            return false;
    }

    const isValidFormat = validateFormat(patt1 || patt2 || patt3);

    if (isValidFormat) {
        // 格式正確 
        return true;
    } else {
        // 格式錯誤 
        return false;
    }
};

import { xhSet, xhGet } from "./xhCookie";
// 判断是否首次进入页面
// 0为假 1为真
export const firstPage = () => {
    if (!xhGet("XH-WEB")?.isRefresh) {
        // 首次进入
        xhSet("XH-WEB", { isRefresh: 1 })
        return true
    } else if (xhGet("XH-WEB")?.isRefresh == 1) {
        // 刷新页面，非首次进入
        xhSet("XH-WEB", { isRefresh: 0 })
        return false
    }
}

export const Storage = {
    set: (key, data) => {
        localStorage.setItem(key, JSON.stringify(data));
    },
    get: key => {
        return JSON.parse(localStorage.getItem(key));
    },
};

export const bottomScroll = () => {
    var windowHeight = window.innerHeight;
    var body = document.body;
    var html = document.documentElement;
    var documentHeight = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
    );
    var scrollableDistance = documentHeight - windowHeight;
    var scrolledDistance =
        window.pageYOffset ||
        (document.documentElement || document.body.parentNode || document.body)
            .scrollTop;

    if (scrollableDistance - scrolledDistance <= 1) {
        return true
    }
}

import qs from "qs";
// 解析URL參數
export const parseUrl = (link) => {
    return qs.parse(link.split("?")[1]);
};

// 敬请期待
import { ElMessage } from "element-plus";
export const Expect = (link, text) => {
    if (link) {
        window.open(link, "_blank");
    } else {
        ElMessage({
            message: text,
            center: true,
            offset: 200,
            type: "success",
        });
    }
};

export const scrollToSpecificHeight = (topValue) => {
    window.scrollTo({
        top: topValue,
        behavior: "smooth",
    });
};